import { render, staticRenderFns } from "./DialogTenderCreateInvoice.vue?vue&type=template&id=1d79c6f7"
import script from "./DialogTenderCreateInvoice.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogTenderCreateInvoice.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports